export * from './angularfire2';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/angularfire2/public_api.js
// module id = ../../../../angularfire2/public_api.js
// module chunks = 4